import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatListNumberedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_list_numbered"}/>
}
